<div class="ap-card" (click)="selectCard()" data-testid="wrapper">
    <div class="ap-card__body" data-testid="body">
        <span [attr.id]="uniqueId">
            <ng-content></ng-content>
        </span>
        <ap-checkbox
            (click)="stopPropagation($event)"
            class="ap-card__checkbox"
            [ariaDescribedby]="uniqueId"
            [label]="checkboxLabel()"
            [formControl]="control()"
            data-testid="checkbox"
        ></ap-checkbox>
    </div>
</div>
